const BASE_PATH = 'COMPANY_USER_PROFILE_INFO';

export const SET_PROFILE_INFO_DATA = `${BASE_PATH}/SET_PROFILE_INFO_DATA`;
export const VALIDATE_PROFILE_INFO_DATA = `${BASE_PATH}/VALIDATE_PROFILE_INFO_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;

export const setProfileInfoData = data => ({
    type: SET_PROFILE_INFO_DATA,
    data
});

export const validateProfileInfoData = () => ({
    type: VALIDATE_PROFILE_INFO_DATA,
});

export const clearProfileInfoData = () => ({
    type: CLEAR_INFO_DATA,
});

const initialState = {
    firstName: "",
    lastName: "",
    email: '',
    mobileNumber: '',
    password: '',

    firstNameError: '',
    lastNameError: '',
    passwordError: '',

    validate: false,
    isValid: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_PROFILE_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case VALIDATE_PROFILE_INFO_DATA:
            return { ...state, validate: true }

        case CLEAR_INFO_DATA:
            return { ...initialState }
    }

    return state;
}